namespace Serenity {
    export class ISlickFormatter {
    }
}